import Grid from "@material-ui/core/Grid";
import Bignumber from "./Bignumber";
import {
  AttachMoney as AttachMoneyIcon,
  HourglassEmpty as HourglassEmptyIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
} from "@material-ui/icons";

import MaskAndValid from "utils/maskAndValid";

export default function BignumbersVendaLink({ data }) {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de links pendentes"
          value={data.vlLinksPendentes}
          icon={HourglassEmptyIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de links pagos"
          value={data.vlLinksPagos}
          icon="far fa-money-bill-alt"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Valor total links pendentes"
          value={
            data.vlValorLinksPendentes !== null
              ? "R$" + MaskAndValid.maskPrice(data.vlValorLinksPendentes)
              : null
          }
          icon={AttachMoneyIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Valor total links pagos"
          value={
            data.vlValorLinksPagos !== null
              ? "R$" + MaskAndValid.maskPrice(data.vlValorLinksPagos)
              : null
          }
          icon={AttachMoneyIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Ticket médio"
          value={
            data.vlTicketMedio !== null
              ? "R$" + MaskAndValid.maskPrice(data.vlTicketMedio)
              : null
          }
          icon={ConfirmationNumberIcon}
        />
      </Grid>
    </Grid>
  );
}
